import { configureStore, combineReducers } from "@reduxjs/toolkit";
import commonReducer from './slices/commonSlice'
import modiferReucer from './slices/modifierSlice'
import productReducer from './slices/productSlice'
import customerGroupReducer from './slices/customerGroupSlice'
import sellScreenSlice from "./slices/sellScreenSlice";
import taxReducer from './slices/taxSlice'
import automaticDiscountReducer from './slices/automaticDiscountSlice'
import viewDiscountReducer from './slices/viewDiscountSlice'
import categoryReducer from './slices/categorySlice'
import locationReducer from './slices/locationSlice'
import manualDiscountReducer from './slices/manualDiscountSlice'
import customerSlice from "./slices/customerSlice";
import payXSlice from './slices/payXGetFreeSlice'
import buyXgetYDiscountReducer from "./slices/buyXgetYDiscountSlice"
import optionSlice from "./slices/optionSlice";
import notificationSlice from "./slices/notificationSlice";
import displayReducer from "./slices/displaySettingSlice"
import invitedStaffSlice from "./slices/invitedStaffSlice";
import rolesSlice from "./slices/rolesSlice";
import brandSlice from "./slices/brandSlice";
import storeSettingSlice from "./slices/storeSettingSlice";
import preferenceSettingSlice from "./slices/preferenceSettingSlice";
import productDetailsSlice from "./slices/productDetailsSlice";
import orderSlice from "./slices/orderSlice";
import Middleware from "./middleware";
import authSlice from "./slices/authSlice";

import orderDetails from './slices/orderDetailSlice'
import staffSlice from './slices/staffSlice'
import activityLog from './slices/activityLogSlice'
import TaxReportSlice from "./slices/taxReport.slice";
import InventorySlice from "./slices/inventorySlice";
import ReadymadeProductSlice from "./slices/readymadeProductSlice";
import orderReportSlice from "./slices/orderReportSlice";
import staffReportSlice from "./slices/staffReportSlice";
import customerReportSlice from "./slices/customerReportSlice";
import offerReportSlice from "./slices/offerReportSlice";
import PaymentReportSlice from "./slices/paymentReport.slice";
import DashboardSlice from "./slices/dashboard.slice";
import newSellscreenSlice from "./slices/newSellscreenSlice"
import receiptSettingsSlice from "./slices/receiptSettingSlice";
import newSellscreenPaymentSlice from "./slices/newSellscreenPaymentSlice";
import soldProductReportSlice from "./slices/soldProductReportSlice";
import RevenueReportSlice from "./slices/revenueReport.slice";
import invitedStaffRoleSlice from "./slices/inviteStaffSlice";
import discountLogsReducer from "./slices/discountLogsSlice";
import zoneSlice from "./slices/zoneSlice";
import viewCustomerDetailsSlice from "./slices/viewCustomerDetails.slice";
import orderSettingsSlice from "./slices/orderSettings.slice";

const appReducer = combineReducers({
        common: commonReducer,
        modifier: modiferReucer,
        product: productReducer,
        customerGroup: customerGroupReducer,
        sellScreen: sellScreenSlice,

        tax: taxReducer,
        automaticDiscount: automaticDiscountReducer,
        viewDiscount: viewDiscountReducer,
        category: categoryReducer,
        location: locationReducer,
        manualDiscount: manualDiscountReducer,
        customer: customerSlice,
        payXDiscount: payXSlice,
        buyXgetYDiscount: buyXgetYDiscountReducer,
        optionSlice: optionSlice,
        notification: notificationSlice,
        display: displayReducer,
        roles: rolesSlice,
        invitedStaff: invitedStaffSlice,
        brands: brandSlice,
        StoreSetting: storeSettingSlice,
        preferenceSetting: preferenceSettingSlice,
        productDetails: productDetailsSlice,
        orderSlice: orderSlice,
        authSlice: authSlice,
        orderDetails: orderDetails,
        staff: staffSlice,
        activityLog: activityLog,
        taxReport: TaxReportSlice,
        inventory: InventorySlice,
        readumadeProdut: ReadymadeProductSlice,
        orderReport: orderReportSlice,
        staffReport: staffReportSlice,
        customerReport: customerReportSlice,
        offerReport: offerReportSlice,
        paymentReport: PaymentReportSlice,
        Dashboard: DashboardSlice,
        NewSellscreenSlice: newSellscreenSlice,
        receiptSettings: receiptSettingsSlice,
        NewSellscreenPaymentSlice: newSellscreenPaymentSlice,
        soldProductReport: soldProductReportSlice,
        revenueReport: RevenueReportSlice,
        inviteStaffRole: invitedStaffRoleSlice,
        discountLogs: discountLogsReducer,
        zoneSlice: zoneSlice,
        viewCustomerDetails: viewCustomerDetailsSlice,
        orderSettings: orderSettingsSlice,
})

const rootReducer = (state: any, action: any) => {
        if (action.type === 'RESET_STORE') {
                state = undefined;
        }
        return appReducer(state, action);
};

export const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
                serializableCheck: false,
        }).concat(Middleware),
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch